// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".custom-section__label{display:inline-block;font-size:12px;text-transform:uppercase;margin:0 0 8px;color:#fa0019;cursor:pointer}.custom-section__collapsible{display:flex;flex-direction:column;transition:height .25s ease-in-out}.custom-section__collapsible--collapsed{height:0;overflow:hidden}", ""]);
// Exports
module.exports = exports;
